/**
 * The walkthrough of automatic inactivation. The rules card's "Instruções" plays it,
 * and so does the login notice while its campaign lasts.
 */
export const INACTIVATION_VIDEO_URL =
  'https://cdn.actuar.com/inativacao_automatica_thenew_escuro_new_2.mp4';

/**
 * Last day (inclusive) the video opens by itself after login, as `yyyy-MM-dd`: in that
 * format alphabetical order is calendar order, so "still on?" is a string comparison.
 *
 * Past it, the notice is dead code and can go: `InactivationVideoNoticeStore`,
 * `InactivationVideoNoticeComponent` and its tag in each core. The card's
 * "Instruções" stays.
 */
export const INACTIVATION_VIDEO_NOTICE_LAST_DAY = '2026-11-10';

/** Local storage key (without the facade's prefix): `{ [TenantId:PersonId]: 'yyyy-MM-dd' }`. */
export const INACTIVATION_VIDEO_NOTICE_STORAGE_KEY = 'inactivation-video-notice/seen';
